import { Controller } from "@hotwired/stimulus"
import {
  lockBodyScroll,
  unlockBodyScroll,
} from "~/controllers/mixins/useBodyScrollLock"

export default class extends Controller {
  static values = {
    open: Boolean,
  }

  connect() {
    const mql = window.matchMedia("(width > 870px)")
    mql.addEventListener("change", this.handleMediaQueryChange.bind(this))
  }

  toggle() {
    this.openValue = !this.openValue
  }

  close() {
    this.openValue = false
  }

  openValueChanged() {
    if (this.openValue) {
      lockBodyScroll()
    } else {
      unlockBodyScroll()
    }
  }

  handleMediaQueryChange(e) {
    if (e.matches) {
      this.openValue = false
    }
  }
}
